// extracted by mini-css-extract-plugin
export default {"root":"EditModal_root__5nFGG","container":"EditModal_container__ys2ac"};